import { FieldProps, SettingCropProps } from 'features/Croptimizer/types';

// TODO: create types for all funcs below in types.ts
export const getOpenFields = (fields: FieldProps[], crops: SettingCropProps[]) => fields.filter((field) => crops.every((crop) => crop.fieldName !== field.title),
);